import { FaInstagram } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { Container } from "./Container";
export function Footer() {
  return (
    <footer className="bg-white dark:bg-gray-800">
      <Container>
        <div className="flex items-center border-t border-slate-400/10 py-1 gap-5 justify-center">

          <div className="flex gap-x-6 ">
            <a
              href="https://www.facebook.com/hyderabadpremiergolfleague/videos/hpgl-season-2-round-5-highlightsmp4/931408710893418/"
              className="group "
              title="facebook"
            >
              <FaFacebook className="w-6 h-6 text-blue-400" />
            </a>
            <a
              href="https://www.instagram.com/hyderabadpremiergolfleague/"
              className="group "
              title="Instagram"
            >
              <FaInstagram className="w-6 h-6 text-pink-400" />
            </a>
          </div>
        </div>
      </Container>
    </footer>
  );
}
